require('./bootstrap');
require('./masks');
require('./cookies');
// require('./animations');
// require('swiper/bundle');

let dropdown = function () {
    var dropdown = document.querySelectorAll('[data-dropdown-toggle]');

    for (let index = 0; index < dropdown.length; index++) {
        const targetElement = dropdown[index];
        targetElement.addEventListener("click", activeDropdown, false);
        targetElement.parentElement.addEventListener("click", function () {
            if(this.classList.contains('active')) {
                this.querySelector('.dropdown-button').click()
            }
        })
    }
    
    function activeDropdown(e) {
        e.stopPropagation()
        var target = this.getAttribute('data-dropdown-toggle')
        var contentDropdown = document.querySelector(`[data-dropdown-content='${target}']`);
   
        if (contentDropdown.classList.contains('hidden')) {
            contentDropdown.classList.remove('hidden')
            contentDropdown.classList.add('block', 'absolute');
            contentDropdown.parentNode.classList.add('active')
            document.querySelector('body').classList.add('active-dropdown');
        } else {            
            contentDropdown.classList.add('hidden');
            contentDropdown.classList.remove('block', 'absolute');
            contentDropdown.parentNode.classList.remove('active');
            document.querySelector('body').classList.remove('active-dropdown');
        }
        
        // fecha menu mobile 
        document.querySelector("header").classList.remove("active");
        document.querySelector(".menu-bar").classList.remove("active");
        // document.querySelector(".navigation-container").classList.remove('active');

    } 

    // var dropdowns = document.querySelectorAll('[data-dropdown-content]');

}

let collapse = function () {
    var collapseToggle = document.querySelectorAll('[data-collapse-toggle]');
    for (let index = 0; index < collapseToggle.length; index++) {
        // collapseToggle.classList.remove('block');
        const targetElement = collapseToggle[index];
        targetElement.addEventListener("click", accordion, false);
    }
    function accordion() {
        var target = this.getAttribute('data-collapse-target');
        
        var allCollapse = document.querySelectorAll('[data-collapse-toggle]');
        for (let index = 0; index < allCollapse.length; index++) {
            const element = allCollapse[index];
            if(element !== this) {
                element.classList.remove('active');
            }
        }
        this.classList.toggle('active');


        var collapseParent = document.querySelector(`[data-collapse-parent='${target}']`); 
        closeAllParents(collapseParent);
  
        collapseParent.classList.toggle('hidden');
        
    } 
    function closeAllParents(removeCurrentTargetFromList) {
        var collapseParents = document.querySelectorAll('.accordion-collapse'); 

        Array.prototype.forEach.call(collapseParents, function (node) {
            if (node !== removeCurrentTargetFromList) {
                node.classList.add('hidden');
            }
        });
    }
}

let sticky = function(offset) {
    // Sticky navigation
    const navbar = document.querySelector(".header");
    let scrollPos = window.scrollY;
  
    window.addEventListener("scroll", function() {
      scrollPos = window.scrollY;

  
      if (scrollPos >= offset) {
        navbar.classList.add("sticky");
      } else {
        navbar.classList.remove("sticky");
      }
    });
}

// generic tabs
let tabs = function() {
    let tabTogglers = document.querySelectorAll(".tab-link");
    tabTogglers.forEach(function (toggler) {
        toggler.addEventListener("click", function (e) {
            e.preventDefault();

            let tabName = '',
                existsDataAttribute = this.getAttribute("data-tab");

            // variation tabs
            if (existsDataAttribute) {
                tabName = this.getAttribute("data-tab");

                for (let i = 0; i < tabTogglers.length; i++) {
                    tabTogglers[i].classList.remove("active");       
                }
                this.classList.add('active');

            } else {
               tabName = this.getAttribute("href");
    
                let tabContents = document.querySelector("#tab-contents");
                
                for (let i = 0; i < tabContents.children.length; i++) {
            
                    tabTogglers[i].classList.remove("active");
                    tabContents.children[i].classList.remove("hidden");
                    if ("#" + tabContents.children[i].id === tabName) {
                        continue;
                    }
                    tabContents.children[i].classList.add("hidden");
            
                }
                e.target.classList.add("active");
            }
        });
    });
}

let privacyBar = function () {
    let togglePrivacy = document.querySelector('.btn-toggle-privacy');

    // let privacyBar = document.querySelector('.privacyBar');
    // togglePrivacy.addEventListener('click', acceptCookies, false)
    
    if (cookieHelper.getCookie("politicas_privacidade_promocao") === null || cookieHelper.getCookie("politicas_privacidade_promocao") == '') {
        setStatePrivacyBar()
    }
    
    function acceptCookies() {
        cookieHelper.setCookie('politicas_privacidade_promocao',1,365)
        setStatePrivacyBar()
    }
    
    function setStatePrivacyBar(old, state) {
        // privacyBar.classList.toggle('hidden')
    }
}

const menu = function() {
    // Grab HTML Elements
	const header = document.querySelector("header");
	const btn = document.querySelector(".mobile-menu-button");
	const menu = document.querySelector(".menu-bar");
	// const navigationContainer = document.querySelector(".navigation-container");

	// fecha dropdown aberto mobile

	btn.addEventListener("click", () => {
        console.log("Clicado!");
        console.log("menu mobile");
        header.classList.toggle("active");
        menu.classList.toggle("active");
        // navigationContainer.classList.toggle('active');
        // fecha dropdown mobile caso esteja ativo
        var dropdown = document.querySelectorAll('.dropdown');
        for (let index = 0; index < dropdown.length; index++) {
            const targetElement = dropdown[index];
            targetElement.classList.remove('block')
            targetElement.classList.add('hidden')
        }
        document.querySelector('body').classList.remove('active-dropdown');
    });
}


const lazyLoadImages = function () {
       
    var lazyloadImages

    if ('IntersectionObserver' in window) {
        lazyloadImages = document.querySelectorAll('.lazy')
    
        var imageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    var image = entry.target
                    image.src = image.dataset.src
                    image.classList.remove('lazy')
                    imageObserver.unobserve(image)
                }
            });
        });

        lazyloadImages.forEach(function (image) {
            imageObserver.observe(image)
        });
        
    } else {
        var lazyloadThrottleTimeout
        lazyloadImages = document.querySelectorAll('.lazy')

        function lazyload() {
            if (lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout)
            }

            lazyloadThrottleTimeout = setTimeout( function() {
                var scrollTop = window.pageYOffset
                
                lazyloadImages.forEach(function (img) {
                    if (img.offsetTop < window.innerHeight + scrollTop) {
                        img.src = img.dataset.src
                        img.classList.remove('lazy')
                    }
                });
                if (lazyloadImages.length == 0) {
                    document.removeEventListener('scroll', lazyload)
                    window.removeEventListener('resize', lazyload)
                    window.removeEventListener('orientationChange', lazyload)
                }
            }, 20)
        }

        document.addEventListener('scroll', lazyload)
        window.addEventListener('resize', lazyload)
        window.addEventListener('orientationChange', lazyload)
    }
}


const toggleTootip = function() {

    let toggleTootip = document.querySelector('.js-tooltip-toggle');
    let toggleTootipContent = document.querySelector('.js-tooltip__content');

    if (!toggleTootip) return;

    toggleTootip.addEventListener('click', function(e) {
        e.preventDefault();
        toggleTootipContent.classList.toggle('active');

        closeTootip();
    })

    function closeTootip() {
        window.onclick = function (event) {
            if (event.target !== toggleTootip) {
                toggleTootipContent.classList.remove('active');
            }
        }
    }

}


document.addEventListener('DOMContentLoaded', function() {
    dropdown();
    collapse();
    masks();
    // animations();
    sticky(5);
    tabs();
    privacyBar();
    menu();
    hashChange();
    lazyLoadImages();
    playVideo();
    toggleTootip();
    
    // if (window.scrollY >= 5) {
    //     document.querySelector(".navbar").classList.add("sticky");
    // }
})

window.onload = function () { 


    // document.querySelectorAll('a[href*="#regulamento"]').forEach(function(el) {
    //     el.addEventListener('click', function(e) {
    //         e.preventDefault();
    //         document.querySelector(".modal-regulamento").style.display = 'flex'
    //         document.querySelector(".modal-regulamento").querySelector('.tab-1').click()
    //     })
    // })

    // document.querySelector(".modal-regulamento").querySelectorAll('.tab').forEach(function (el) {
    //     el.addEventListener('click', function (e) {
    //         var element = null
    //         if (e.target.classList.contains('tab')) {
    //             element = e.target
    //         } else {
    //             element = e.target.parentNode
    //         }

    //         e.preventDefault()
    //         document.querySelector(".modal-regulamento").querySelectorAll('.tab').forEach(function (tab) {
    //             tab.classList.remove('active')
    //         })
    //         element.classList.add('active')
    //         document.querySelector(".modal-regulamento").querySelector('.iframe-pdf').src = element.dataset.url
    //         document.querySelector(".modal-regulamento").querySelector('.btn').href = element.dataset.url + '/download'
    //     })
    // })

    // if (window.location.hash && window.location.hash == "#regulamento") {
    //     document.querySelector(".modal-regulamento").style.display = 'flex'
    //     document.querySelector(".modal-regulamento").querySelector('.tab-1').click()
    // }

    // document.querySelector(".modal-regulamento").querySelectorAll('.close-regulamento').forEach(function (el) {
    //     el.addEventListener('click', function (e) {
    //         e.preventDefault()
    //         document.querySelector(".modal-regulamento").style.display = 'none'
    //     })
    // })


    document.querySelector('nav').querySelectorAll('a').forEach(function(el) {
        el.addEventListener('click', function(e) {
            var btn = document.querySelector(".mobile-menu-button")
            var menu = document.querySelector(".menu-bar")
    
            if (menu.classList.contains('active')) {
                btn.click()
            }
        })
    })

    
    document.querySelectorAll('.faq-question-buttom').forEach(function(el) {
        el.addEventListener('click', function (e) {
            let duvidas = document.querySelector('#duvidas');
            window.scroll(0, duvidas.offsetTop + this.offsetTop)
        })
    })

    document.querySelectorAll('.close-modal').forEach(function(el) {
        el.addEventListener('click', function(e) {
            e.preventDefault()
            document.querySelectorAll('.my-modal').forEach(function(modal) {
                modal.style.display = 'none'
            })
        })
    })

    // document.querySelector('nav').querySelectorAll('a[href*="#"]:not([href="#"])').forEach(function(el) {
    //     el.addEventListener('click', function(e) {
    //         if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
    //             var target = document.querySelector(this.hash);

    //             target = target.length ? target : document.querySelector('[name=' + this.hash.slice(1) + ']');
    //                 if (target) {
    //                 document.querySelector('html, body').animate({
    //                 scrollTop: target.offset().top - 100
    //                 }, 500);
    //                 return false;
    //             }
    //         }
    //     })
    // })

    // $('a[href*="#"]:not([href="#"])').click(function () {

    //     if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
    //       var target = $(this.hash);

    //       target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    //       if (target.length) {
    //         $('html, body').animate({
    //           scrollTop: target.offset().top - 100
    //         }, 500);
    //         return false;
    //       }
    //     }
    // });

    
    // if(window.location.hash.length > 1) {
    //     if (document.querySelector(window.location.hash)) {
    //         setTimeout(function () {
    //             console.log(document.querySelector(window.location.hash).offsetTop);
    //             window.scroll(0, document.querySelector(window.location.hash).offsetTop - 70)
    //         }, 1000)
    //     }
    // }

    
}

function hashChange() {
    if (window.location.hash && window.location.hash == "#contato") {
        let faqTabContact = document.querySelector('.contact-accordion');
        let faqTabContactContent = document.querySelector('.contact-collapse');
        
        faqTabContact.classList.add('active')
        faqTabContactContent.classList.remove('hidden')

        let duvidas = document.querySelector('#duvidas');
        
        setTimeout(function () {
            window.scroll(0, duvidas.offsetTop + document.querySelector(window.location.hash).offsetTop)
        }, 1000)

    }
}

function playVideo() {
    let YouTubeContainers = document.querySelectorAll(".play-video");
    let containerVideo = document.querySelector(".embed-youtube");
  
    // Iterate over every YouTube container you may have
    for (let i = 0; i < YouTubeContainers.length; i++) {
      let container = YouTubeContainers[i];
 
      // When the user clicks on the container, load the embedded YouTube video
      container.addEventListener("click", function() {
        let iframe = document.createElement( "iframe" );
  
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "");
        iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
        // Important: add the autoplay GET parameter, otherwise the user would need to click over the YouTube video again to play it 
        iframe.setAttribute("src", "https://www.youtube.com/embed/"+ this.dataset.videoId +"?rel=0&showinfo=0&autoplay=1");

        this.remove();
        // Clear Thumbnail and load the YouTube iframe
        containerVideo.innerHTML = "";
        containerVideo.appendChild( iframe );
      });
    }
}


